import {
  apply, call, delay, fork, put, select,
} from 'redux-saga/effects';
import {
  getClientAlias,
  getLanguage,
  getMatchStatus,
  getOddsPanelConfig,
  getShowOdds,
} from '../../reducers';
import { MatchMarketsConfigRequest } from '../../../lib/matchMarkets-api';
import { pollFishnet, pollTillResponse } from '../utilLCR';
import { sagaCancel, sagaRunning } from '../utilSagas';
import { isEnded, isLive, isNotStarted } from '../../utils/matchstatus';
import updateMatchMarkets from '../../actions/matchMarkets';

function* loadMatchMarkets(matchId, specifier = false, isBookmaker = false) {
  const clientAlias = yield select(getClientAlias);
  const language = yield select(getLanguage);
  const hasOddsPanelConfig = yield select(getOddsPanelConfig);
  const showOdds = yield select(getShowOdds);

  if (!hasOddsPanelConfig || !showOdds) {
    // If odds panel config is not available or showOdds:false, we don't load betstop
    return;
  }

  let request;
  if (isBookmaker) {
    request = new MatchMarketsConfigRequest(matchId, null, clientAlias, language);
  } else {
    request = new MatchMarketsConfigRequest(matchId, specifier, clientAlias, language);
  }
  const betstop = yield apply(request, request.get);

  yield put(updateMatchMarkets(betstop));
}

function* pollMatchMarketsConfig(matchId) {
  let status;
  let taskPre;
  let taskLive;

  yield call(pollTillResponse, { logLevel: 5 }, loadMatchMarkets, matchId, null, true); // atleast once

  while (true) {
    status = yield select(getMatchStatus, matchId);

    if (!sagaRunning(taskPre) && isNotStarted(status)) {
      taskPre = yield fork(
        pollFishnet,
        { pollInterval: 50000 },
        loadMatchMarkets,
        matchId,
        false, // prematch
      );
    } else if (!sagaRunning(taskLive) && isLive(status)) {
      taskPre = sagaCancel(taskPre);
      taskLive = yield fork(
        pollFishnet,
        { pollInterval: 3000 },
        loadMatchMarkets,
        matchId,
        true, // live
      );
    } else if (isEnded(status)) {
      yield delay(4000 + 1000); // 5 seconds
      taskPre = sagaCancel(taskPre);
      taskLive = sagaCancel(taskLive);
    }
  }
}

export default pollMatchMarketsConfig;
